import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Payment' },
    { value: 2, label: 'Transfer' },
    { value: 3, label: 'Discount / Exemption' },
    { value: 4, label: 'Refund' },
    { value: 5, label: 'Writeoff' },
    { value: 6, label: 'Void' },
    { value: 7, label: 'Apportionment' },
    { value: 9, label: 'Adjustment' },
  ],
});
